import { ComponentProps, FC } from 'react';

import { Icon } from './Icon';

export const IconCalendarWithTick: FC<ComponentProps<typeof Icon>> = (props) => (
  <Icon {...props} viewBox="0 0 40 40">
    <path d="m19.302 29.747 9.04-9.04-1.414-1.414-7.626 7.626-4.293-4.293-1.414 1.414 5.707 5.707Z" />
    <path
      fillRule="evenodd"
      d="M15.302 4v2.667h11.333V4h2v2.667h4A3.333 3.333 0 0 1 35.97 10v21.667A3.333 3.333 0 0 1 32.635 35H9.302a3.333 3.333 0 0 1-3.333-3.333V10a3.333 3.333 0 0 1 3.333-3.333h4V4h2Zm11.333 4.667v4h2v-4h4c.737 0 1.334.597 1.334 1.333v5.667h-26V10c0-.736.597-1.333 1.333-1.333h4v4h2v-4h11.333Zm-18.666 9h26v14c0 .736-.597 1.333-1.334 1.333H9.302a1.333 1.333 0 0 1-1.333-1.333v-14Z"
      clipRule="evenodd"
    />
  </Icon>
);
